import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { MFieldProps } from '../types';
import { CurrencyNumber as CurrencyNumberInput } from '../move_me/CurrencyNumber';

export type NumProps = MFieldProps<
  React.ComponentProps<typeof CurrencyNumberInput>
>;
export const CurrencyNumber = React.forwardRef<HTMLInputElement, NumProps>(
  (
    {
      name,
      validate,
      className,
      onChange: customOnChange,
      inputClassName,
      disabled,
      required,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        className={className}
        disabled={disabled}
        required={required}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, name, ...nother },
          }: FieldRenderProps<number>) => {
            return (
              <CurrencyNumberInput
                ref={ref}
                {...other}
                {...nother}
                name={name}
                value={value}
                onChange={(value) => onChange({ target: { name, value } })}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
